import { Link } from 'react-router-dom';

export { CarsUnder30kHero };
export default CarsUnder30kHero;

function CarsUnder30kHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-50 to-white py-16 lg:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-star-line"></i>
            <span>Premium Selection</span>
          </div>
          
          <h1 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Cars Under $30k That Feel Like They Cost More
          </h1>
          
          <p className="text-lg lg:text-xl text-slate-600 mb-8 leading-relaxed">
            This is the sweet spot: new enough to have modern safety features, old enough to avoid the "new car tax." 
            You're getting leather seats, backup cameras, and Bluetooth — without the $50,000 price tag or the 
            "market adjustment" fee that Portland dealers love to tack on.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
            <Link
              to="/inventory"
              className="inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-800 transition-colors whitespace-nowrap"
            >
              <span>Browse Premium Inventory</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/financing"
              className="inline-flex items-center gap-2 bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold border-2 border-slate-200 hover:border-slate-300 transition-colors whitespace-nowrap"
            >
              <i className="ri-calculator-line"></i>
              <span>Calculate Payment</span>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-calendar-check-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="font-bold text-slate-900 mb-2">2018-2022 Models</h3>
              <p className="text-sm text-slate-600">
                Modern tech, proven reliability, and low enough mileage that you're not inheriting someone else's problems.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-star-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="font-bold text-slate-900 mb-2">Certified Pre-Owned Quality</h3>
              <p className="text-sm text-slate-600">
                Without the CPO markup. We do the same inspections, we just don't charge you $3,000 for the privilege.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-price-tag-3-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="font-bold text-slate-900 mb-2">Fair Market Pricing</h3>
              <p className="text-sm text-slate-600">
                No "market adjustments," no dealer add-ons, no surprise fees. Just honest pricing from the start.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
